import React from "react";
import { findAllFormTemplatePagedEvent } from "../../_events/form_template/find.event";
import { alertError } from "../../_utils/alerts";

export const useFormTemplatePaged = (page = 0, limit = 8 ) => {

    const [data, setData] = React.useState([]);

    const loadData = (p, l) => {
        findAllFormTemplatePagedEvent(p, l)
        .then(json => {
            setData(json.paged);
        })
        .catch(err => {
            alertError(err.message);
        });
    }

    React.useEffect(() => {
        loadData(page, limit);
    }, [page, limit]);

    return { data, loadData };
}